export default function AdsTableSkeleton() {
  return (
    <div className="space-y-3">
      {[0, 1, 2, 3, 4].map((row) => (
        <div key={row} className="flex items-center gap-4">
          <div className="size-10 animate-pulse rounded bg-gray-200" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
            <div className="h-3 w-1/2 animate-pulse rounded bg-gray-200" />
          </div>
          {[0, 1, 2, 3].map((cell) => (
            <div key={cell} className="h-4 w-16 animate-pulse rounded bg-gray-200" />
          ))}
        </div>
      ))}
    </div>
  )
}
